import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row q-gutter-sm q-my-sm" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = {
  key: 0,
  class: "row justify-between q-mt-sm"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = {
  key: 1,
  class: "row q-gutter-sm q-my-sm"
}
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "text-weight-bold" }
const _hoisted_11 = { class: "row q-gutter-sm q-my-sm" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "row q-gutter-sm" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_TypeAheadStores = _resolveComponent("TypeAheadStores")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_ModalTravelMileage = _resolveComponent("ModalTravelMileage")!
  const _component_ModalPromptDelete = _resolveComponent("ModalPromptDelete")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_q_input, {
              "model-value": 
            _ctx.useFormatDate(_ctx.start).time({
              hour: 'numeric',
              minute: 'numeric',
              hourCycle: 'h23',
            })
          ,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = (val) => (_ctx.isValidDate(val) ? _ctx.updateStart(_ctx.toDate(val, _ctx.date) as Date) : undefined)),
              ref: "startRef",
              "reactive-rules": "",
              rules: [
            (val) => _ctx.isValidDate(val) || '',
            (val) => _ctx.rules.beforeNow(_ctx.toDate(val, _ctx.date)) || _ctx.formLabel('notBeforeNow'),
            (val) => _ctx.rules.beforeEnd(_ctx.toDate(val, _ctx.date)) || _ctx.formLabel('startOverlapEnd'),
            (val) =>
              _ctx.rules.notBetweenTimers(_ctx.toDate(val, _ctx.date), _ctx.index) || _ctx.formLabel('betweenActivities'),
            (val) =>
              _ctx.rules.notOverlap(_ctx.toDate(val, _ctx.date), 'start', _ctx.index) || _ctx.formLabel('overlapActivities'),
          ],
              color: "accent",
              filled: "",
              type: "time",
              label: _ctx.formLabel('startTime'),
              disable: _ctx.traveling
            }, null, 8, ["model-value", "rules", "label", "disable"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_q_input, {
              modelValue: _ctx.startOdo,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.startOdo) = $event)),
              modelModifiers: { number: true },
              ref: "startOdoRef",
              type: "number",
              filled: "",
              color: "accent",
              label: _ctx.formLabel('startOdo'),
              "reactive-rules": "",
              rules: [
            (val) => (_ctx.endOdo ? _ctx.odoRules.beforeEnd(val) : true || _ctx.formLabel('odometerLarger')),
            (val) => _ctx.odoRules.noDecimal(val) || 'No decimals allowed'
          ],
              disable: _ctx.traveling
            }, null, 8, ["modelValue", "label", "rules", "disable"])
          ])
        ]),
        (_ctx.initContinue || _ctx.traveling || _ctx.insert)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationInputs, (loc, locIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "row q-gutter-sm q-my-sm",
                  key: loc.name
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_TypeAheadStores, {
                      modelValue: loc.ref,
                      "onUpdate:modelValue": ($event: any) => ((loc.ref) = $event),
                      disable: _ctx.traveling,
                      ref_for: true,
                      ref: (_ctx.getLocationRef(locIndex) as any),
                      label: loc.label,
                      rules: [
              (val) =>
                _ctx.destinationRules.selectionNotNull(loc.ref) || _ctx.errorMessage('locationNotNull'),
              (val) => _ctx.destinationRules.notBothHome() || _ctx.errorMessage('departDestNotSame'),
              (val) => _ctx.destinationRules.storesDifferent() || _ctx.errorMessage('departDestNotSame'),
            ]
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "disable", "label", "rules"])
                  ])
                ]))
              }), 128)),
              (
          _ctx.destination && _ctx.destination.type === 'store' && _ctx.destination.address && !_ctx.edit && !_ctx.insert
        )
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("a", {
                      target: "_blank",
                      href: `
          https://www.google.com/maps/place/
          ${_ctx.destination.address.street.replaceAll(' ', '+')},
          +${_ctx.destination.address.city},
          +${_ctx.destination.address.state}
          +${_ctx.destination.address.zip}`
                    }, [
                      _createElementVNode("div", null, [
                        _createTextVNode(_toDisplayString(_ctx.destination.address.street), 1),
                        _hoisted_7,
                        _createTextVNode(" " + _toDisplayString(_ctx.destination.address.city) + ", " + _toDisplayString(_ctx.destination.address.state) + " " + _toDisplayString(_ctx.destination.address.zip), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_q_btn, {
                          round: "",
                          color: "secondary",
                          icon: "map"
                        })
                      ])
                    ], 8, _hoisted_6)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.traveling)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.formLabel('travelingMessage')), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (!_ctx.traveling && (_ctx.stopped === true || _ctx.insert))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_q_input, {
                    "model-value": 
              _ctx.useFormatDate(_ctx.end).time({
                hour: 'numeric',
                minute: 'numeric',
                hourCycle: 'h23',
              })
            ,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = (val) => (_ctx.isValidDate(val) ? _ctx.updateEnd(_ctx.toDate(val, _ctx.date) as Date) : undefined)),
                    ref: "endRef",
                    "reactive-rules": "",
                    rules: [
              (val) => _ctx.isValidDate(val) || '',
              (val) => _ctx.rules.beforeNow(_ctx.toDate(val, _ctx.date)) || _ctx.formLabel('notBeforeNow'),
              (val) => _ctx.rules.afterStart(_ctx.toDate(val, _ctx.date)) || _ctx.formLabel('endOverlapStart'),
              (val) =>
                _ctx.rules.notBetweenTimers(_ctx.toDate(val, _ctx.date), _ctx.index) || _ctx.formLabel('betweenActivities'),
              (val) =>
                _ctx.rules.notOverlap(_ctx.toDate(val, _ctx.date), 'end', _ctx.index) || _ctx.formLabel('overlapActivities'),
            ],
                    color: "accent",
                    filled: "",
                    type: "time",
                    label: _ctx.formLabel('endTime')
                  }, null, 8, ["model-value", "rules", "label"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_q_input, {
                    modelValue: _ctx.endOdo,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.endOdo) = $event)),
                    modelModifiers: { number: true },
                    ref: "endOdoRef",
                    type: "number",
                    filled: "",
                    color: "accent",
                    label: _ctx.formLabel('endOdo'),
                    "reactive-rules": "",
                    rules: [
              (val) => _ctx.odoRules.beforeStart(val) || _ctx.formLabel('odometerLarger'),
              (val) => _ctx.odoRules.noDecimal(val) || 'No decimals allowed'
              ]
                  }, null, 8, ["modelValue", "label", "rules"])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_q_input, {
                    filled: "",
                    "bg-color": "white",
                    color: "accent",
                    modelValue: _ctx.duration,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.duration) = $event)),
                    readonly: "",
                    label: _ctx.formLabel('duration')
                  }, null, 8, ["modelValue", "label"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_q_input, {
                    filled: "",
                    "bg-color": "white",
                    color: "accent",
                    modelValue: _ctx.distance,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.distance) = $event)),
                    readonly: "",
                    label: _ctx.formLabel('distance')
                  }, null, 8, ["modelValue", "label"])
                ])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_q_card_actions, {
      align: "right",
      class: "text-primary"
    }, {
      default: _withCtx(() => [
        (!_ctx.traveling && !_ctx.stopped && !_ctx.insert)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _withDirectives(_createVNode(_component_q_btn, {
                flat: "",
                label: _ctx.formLabel('close'),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.close()))
              }, null, 8, ["label"]), [
                [_directive_close_popup]
              ]),
              (!_ctx.initContinue)
                ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                    key: 0,
                    color: "primary",
                    label: _ctx.formLabel('continue'),
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.initContinue = true))
                  }, null, 8, ["label"])), [
                    [_directive_close_popup]
                  ])
                : _createCommentVNode("", true),
              (_ctx.initContinue && _ctx.destination && _ctx.departing)
                ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                    key: 1,
                    color: "primary",
                    label: _ctx.formLabel('startTravel'),
                    onClick: _ctx.travel
                  }, null, 8, ["label", "onClick"])), [
                    [_directive_close_popup]
                  ])
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.traveling && !_ctx.stopped)
          ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
              key: 1,
              color: "primary",
              label: _ctx.formLabel('stopTravel'),
              size: "lg",
              class: "full-width",
              onClick: _ctx.stop
            }, null, 8, ["label", "onClick"])), [
              [_directive_close_popup]
            ])
          : _createCommentVNode("", true),
        (!_ctx.traveling && _ctx.isIncomplete)
          ? (_openBlock(), _createBlock(_component_q_btn_dropdown, {
              key: 2,
              color: "primary",
              split: "",
              onClick: _ctx.saveTravel
            }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.formLabel('saveTravel')), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_q_list, null, {
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                      clickable: "",
                      onClick: _ctx.removeTravel
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.formLabel('delete')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"])), [
                      [_directive_close_popup]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.traveling && _ctx.insert && !_ctx.isIncomplete)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              (_ctx.insert)
                ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                    key: 0,
                    clickable: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.formLabel('cancel')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })), [
                    [_directive_close_popup, 2]
                  ])
                : _createCommentVNode("", true),
              (_ctx.insert && !_ctx.index && _ctx.index != 0)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 1,
                    color: "primary",
                    split: "",
                    onClick: _ctx.insertOrEditTravel,
                    label: _ctx.formLabel('saveTravel')
                  }, null, 8, ["onClick", "label"]))
                : _createCommentVNode("", true),
              (_ctx.index || _ctx.index == 0)
                ? (_openBlock(), _createBlock(_component_q_btn_dropdown, {
                    key: 2,
                    color: "primary",
                    split: "",
                    onClick: _ctx.insertOrEditTravel
                  }, {
                    label: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.formLabel('saveTravel')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_q_list, null, {
                        default: _withCtx(() => [
                          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            clickable: "",
                            onClick: _ctx.promptRemoveTravel
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.formLabel('delete')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"])), [
                            [_directive_close_popup]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_ModalTravelMileage, {
      modelValue: _ctx.modalTravelMileage,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.modalTravelMileage) = $event)),
      "stop-travel": _ctx.mileageTooLarge,
      onConfirmTravel: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isIncomplete ? _ctx.save() : _ctx.insertOrEdit()))
    }, null, 8, ["modelValue", "stop-travel"]),
    _createVNode(_component_ModalPromptDelete, {
      modelValue: _ctx.modalPromptDelete,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modalPromptDelete) = $event)),
      onConfirmDelete: _ctx.removeTravel
    }, null, 8, ["modelValue", "onConfirmDelete"])
  ], 64))
}